import { Route as CompanySettingsRoute } from "@/routes/_authenticated/companies/$companyId/_dashboard/settings.tsx";
import {
  TopSectionColumn,
  TopSectionDescription,
  TopSectionHeading,
  TopSectionRow,
} from "@/components/sections/top-section";
import { T } from "@transifex/react";
import { ChargingNoteSettingsCard } from "@/pages/company-settings-page/components/charging-note-settings-card.tsx";
import { InvoiceSpecificationCard } from "@/pages/company-settings-page/components/invoice-specification-card.tsx";

export const CompanySettingsPage: React.FC = () => {
  const data = CompanySettingsRoute.useLoaderData();

  return (
    <>
      <TopSectionRow className="mb-14 ">
        <TopSectionColumn className="w-full md:w-3/4">
          <TopSectionHeading>
            <T _str="Company settings" />
          </TopSectionHeading>
          <TopSectionDescription>
            <T _str="Edit settings for your company." />
          </TopSectionDescription>
        </TopSectionColumn>
      </TopSectionRow>
      <ChargingNoteSettingsCard data={data} />
      <InvoiceSpecificationCard data={data} />
    </>
  );
};
